export default "__VITE_ASSET__ByJ6hT13__"